import React from 'react';
import RUSEYouthPlatform from './components/RUSEYouthPlatform';

function App() {
  return (
    <div className="App">
      <RUSEYouthPlatform />
    </div>
  );
}

export default App;
